import styled from 'styled-components';
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import {
    Cabecalho, Propaganda, NavBAr, Navegacao, Logo, ContaiterLogo, Links, NavLinks, ImgShop, ContainerShop, Pesquisa, ContainerPesquisa, BarraPesquisa,
    ContainerCompra, Usuario, Favorito, Sacola, MenuMobile, Input, CarrinhoCompras, CarrinhoHeader, ContainerCarrinhoP,
    ContainerP, ContainerSacolinha, CarrinhoMain, CarrinhoRodape, CardP, ImgCardP, ContainerCardp, ContainerProduto,
    DadosProduto, NomeProduto, ContainerRemover, ContainerValoresP, UnidadeP, VezesP, ValorP, CarrinhoValor, ContainerSubtotal,
    SubtotalP, ContainerValorTotal, ValorTotalP, ContainerFinalizar, ButtonFinalizar, ContainerFinalizarP, FinalizarP,
    ContinuarCompraP, IconMaior, MenuMobileLateral, ContainerMenuMobile, Shop, ContainerTitulo, Titulo, Pagina, MaisOpcoesMobile, PesquisaMobile,BarraPesquisaMobile,ContainerBarraPesquisaMobile,OpcoesMobile,CadastroBox,
    ContainerOpcoes,UsuarioMobile,ButtonContaMobile,Contap,ContainerTituloMobile,ContainerSeta,Paginas
} from './Home.style.js';

import MenuImage from '../components/assets/menu.png';
import MarcaCruzada from '../components/assets/marca-cruzada.png';

import PesquisaSvg from '../components/svg/pesquisa.svg';
import UsuarioSvg from '../components/svg/usuario.svg';
import FavoritoSvg from '../components/svg/favorito.svg';
import SacolaSvg from '../components/svg/sacola.svg';
import SacolaSairSvg from '../components/svg/sacolaSair.svg';
import ExcluirSvg from '../components/svg/excluir.svg';
import Maior2 from '../components/svg/maior2.svg';
import MaisOpcoes from '../components/svg/maisopcoes.svg';
import SairOpcoes from '../components/svg/sairOpcoes.svg';
import SetaAcordeon from '../components/svg/setaAcordeon.svg';
import SetaPagina from '../components/svg/setaPagina.svg';
import Adcionar from '../components/svg/adcionar.svg';
import Remover from '../components/svg/remover.svg';
import LupaPesquisa from '../components/svg/lupaPesquisa.svg';
import API from '../examples/modelo_api_home.json'

 
const StyledSVG = styled.svg`
    transition: transform 0.3s ease;
    transform: rotate(${props => props.shopVisivel ? '-180deg' : '0deg'});
    margin-left: 10px;
`;
 
function HeaderPage({DadosAPI}) {

 
    // Extraindo dados do JSON
    const propagandaData = DadosAPI.cabecalho;


    if(propagandaData == null || propagandaData.length == 0){
        return <></>;
    }

  
 
    return (
        <Cabecalho>
            <Propaganda style={{ backgroundColor: propagandaData[0].barratopobackgroundcolor, color: propagandaData[0].barratopocolor,textAlign:'-webkit-center'}}>{propagandaData[0].barratopotitulo}<p></p></Propaganda>
        </Cabecalho>
    );
}

export default HeaderPage;
